import React from 'react'
import { useParams } from 'react-router-dom'
import BookingPaymentSuccessState from './BookingPaymentSuccessState'
import MemberBookingSuccess from '../components/MemberBookingSuccess'

export default function MemberRacquetBookingSuccessPage({ clubCode }) {
  const { sportType } = useParams()
  return <BookingPaymentSuccessState clubCode={clubCode} module="racquet" sportType={sportType}>
    <MemberBookingSuccess clubCode={clubCode} module="racquet" />
  </BookingPaymentSuccessState>
}
